<template>
  <!-- banner topo -->
  <div v-if="bannerTopo != ''" class="bannerTopo-area">
    <div class="bannerTopo-height d-flex align-items-center">

      <div class="bannerTopo-img">
        <img :src="$imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem" class="bannerTopo-bg-fill" alt="">
      </div>

      <div class="bannerTopo-overlay"></div>

      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-8 col-lg-10">
            <div class="bannerTopo-caption text-center">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Blog -->
  <section v-if="listaBlog && listaBlog.length > 0" class="blog_area section-padding">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 mb-lg-0">
          <div class="blog_left_sidebar">

            <article v-for="noticia in primeiraNoticia" :key="noticia.itiId" class="blog_item">
              <div class="blog_item_img">
                <img v-if="noticia.insInstitucionalImagens.length"
                  :src="$imgURL + noticia.insInstitucionalImagens[0].itgUrlImagem" class="card-img rounded-0">
                <div class="blog_item_date">
                  <h3>{{ formattedDateDia(noticia.itiData1) }}</h3>
                  <p>{{ formattedDateMes(noticia.itiData1) }}</p>
                </div>
              </div>
              <div class="blog_details">
                <router-link :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)">
                  <h2>{{ noticia.itiNome }}</h2>
                </router-link>
                <p>{{ resumoCurto(noticia.itiResumo1) }}</p>
                <ul class="blog-info-link">
                  <li>
                    <router-link :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)">
                      Leia mais
                    </router-link>
                  </li>
                </ul>
              </div>
            </article>

          </div>
        </div>

        <div class="col-lg-4">
          <div class="blog_right_sidebar">

            <aside class="single_sidebar_widget popular_post_widget">
              <h3 class="widget_title" style="color: #2d2d2d;">ùltimas notícias</h3>
              <div v-for="noticiaPequena in listaBlog" :key="noticiaPequena.itiId"
                class="media post_item img-avance-blog">
                <img :src="$imgURL + noticiaPequena.insInstitucionalImagens[0].itgUrlImagem" style="max-width: 100px;"
                  alt="post">
                <div class="media-body">
                  <router-link :to="'/BlogDetalhe/' + noticiaPequena.itiId + '/' + formataLink(noticiaPequena.itiNome)">
                    <h3>{{ noticiaPequena.itiNome }}</h3>
                  </router-link>
                </div>
              </div>
            </aside>

          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';

export default {
  name: 'BlogView',
  components: {
  },

  data: () => ({
    bannerTopo: [],
    listaBlog: [],
    listaNoticias: [],
    firstNoticia: [],
    otherNoticas: [],
    finalNoticias: [],
  }),

  computed: {
    primeiraNoticia() {
      return this.listaBlog.length > 0 ? [this.listaBlog[0]] : [];
    }
  },

  methods: {

    formattedDateDia(value) {
      return this.$moment(value).format('DD')
    },

    formattedDateMes(value) {
      const mes = this.$moment(value).format('MMMM')
      return mes.charAt(0).toUpperCase() + mes.slice(1)
    },

    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    /* resumo curto da primeira noticia */
    resumoCurto(conteudo) {
      const textoLimpo = this.removerTagsHTML(conteudo);
      const limite = 200; // você pode ajustar esse número
      return textoLimpo.length > limite ? textoLimpo.slice(0, limite) + '...' : textoLimpo;
    },

    filtraNoticia(categoria) {
      let _filtro = this.listaNoticias.filter(x => x.itiReferencia == categoria);
      this.firstNoticia = _filtro[0];
      this.otherNoticas = _filtro.slice(1, 6);
      this.finalNoticias = _filtro.slice(7);
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Lukon :: ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Avance Digital" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

  },

  created() {
    this.carregaMetas("---");

    // TOPO BANNER
    axios.get('/Process/InsInstitucional/institucional/27/toponoticias/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML, this.bannerTopo[0].itiNome);
        //console.log('banner topo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    // NOTICIAS
    axios.get('/Process/InsInstitucional/institucional/50/noticias/0/itiData1')
      .then(response => {
        this.listaBlog = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const timeA = a.itiData1
            ? new Date(a.itiData1).getTime()
            : 0;
          const timeB = b.itiData1
            ? new Date(b.itiData1).getTime()
            : 0;
          return timeA - timeB;
        }).reverse();
        console.log('listaBlog')
        console.log(this.listaBlog)
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style scoped></style>